import ApiArticle from 'types/api/Article';
import { ApiResources } from 'types/apiResources';
import { Endpoints, ListParamsDefault } from 'types/endpoints';
import ListCollection from 'types/redux/ListCollection';

import Article, { Roles, Types } from 'models/Article';

import { LIST_MARKUP } from 'consts/redux';
import { withVariables } from 'utils/string';
import { request } from 'services/Api';

export interface ListParams extends ListParamsDefault {
    categorySlug?: string;
    type?: Types;
    role?: Roles;
}
export const list = async (params?: ListParams): Promise<ListCollection<Article>> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicArticles, params),
        requestParams: params,
    });

    const data = response?.payload?.data;
    const resource = data && data[ApiResources.Articles];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return {
        ...LIST_MARKUP,
        isLoaded: true,
        elements: resource
            .elements
            .map((element: ApiArticle) => new Article(element)),
        meta: resource.meta,
    };
};

export interface SingleParams {
    slug: string;
}
export const single = async (params: SingleParams): Promise<Article> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicArticle, params),
    });

    const data = response?.payload?.data;
    const resource: ApiArticle = data && data[ApiResources.Article];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return new Article(resource);
};
